<script>
  export default {
    name: 'Tab',
    inject: ['addTab', 'activeTabKey', 'setActiveTabKey', 'setTabTitle'],
    props: {
      title: {
        type: String,
        required: true,
      },
      eager: { type: Boolean, default: false },
      noTranslate: { type: Boolean, default: false },
      active: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
    },
    emits: ['activated'],
    data() {
      return { key: '', isActive: false, wasActive: false }
    },
    watch: {
      activeTabKey() {
        this.isActive = this.activeTabKey === this.key
      },
      isActive(n, _) {
        if (n) {
          this.wasActive = true
        }
      },
    },
    created() {
      this.key = `#${this.title.toLowerCase().replace(/ /g, '-')}`
      this.addTab({
        title: this.title,
        key: this.key,
        translate: !this.noTranslate,
        ref: this,
      })
      if (this.active) {
        this.activate()
      }
    },
    methods: {
      setTitle(v) {
        this.setTabTitle(this.key, v)
      },
      activate() {
        if (!this.disabled) {
          this.setActiveTabKey(this.key)
          this.$emit('activated')
        }
      },
    },
  }
</script>

<template>
  <div v-if="eager || wasActive" v-show="isActive">
    <slot />
  </div>
</template>

<style scoped></style>
